import { createApi } from '@reduxjs/toolkit/query/react';

import { networkBaseQueryV2 } from './queries';

export const talentAttractionApi = createApi({
  reducerPath: 'talentAttractionApi',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['TalentAttractionDashboard', 'TalentAttractionProjects', 'TalentAttractionJobs'],
  endpoints: (builder) => ({
    getTalentAttractionDashboard: builder.query({
      query: ({ dateFrom, dateTo, networkId } = {}) => ({
        url: '/talent_attraction/dashboard',
        params: dateFrom && dateTo ? { dateFrom, dateTo } : undefined,
        networkId,
      }),
      providesTags: ['TalentAttractionDashboard'],
    }),
    getTalentAttractionProjects: builder.query({
      query: ({ dateFrom, dateTo, networkId } = {}) => ({
        url: '/talent_attraction/projects',
        params: dateFrom && dateTo ? { dateFrom, dateTo } : undefined,
        networkId,
      }),
      providesTags: ['TalentAttractionProjects'],
    }),
    getTalentAttractionJobs: builder.query({
      query: ({ query, projectId, networkId } = {}) => ({
        url: '/talent_attraction/jobs',
        params: { query, projectId },
        networkId,
      }),
      providesTags: ['TalentAttractionJobs'],
    }),
    updateTalentAttractionMapping: builder.mutation({
      query: ({ projectId, jobId, networkId }) => ({
        url: `/talent_attraction/projects/${projectId}/job`,
        method: 'PUT',
        data: { jobId },
        networkId,
      }),
      invalidatesTags: ['TalentAttractionDashboard', 'TalentAttractionProjects', 'TalentAttractionJobs'],
    }),
    removeTalentAttractionMapping: builder.mutation({
      query: ({ projectId, networkId }) => ({
        url: `/talent_attraction/projects/${projectId}/job`,
        method: 'DELETE',
        networkId,
      }),
      invalidatesTags: ['TalentAttractionDashboard', 'TalentAttractionProjects', 'TalentAttractionJobs'],
    }),
  }),
});

export const {
  useGetTalentAttractionDashboardQuery,
  useGetTalentAttractionProjectsQuery,
  useLazyGetTalentAttractionJobsQuery,
  useUpdateTalentAttractionMappingMutation,
  useRemoveTalentAttractionMappingMutation,
} = talentAttractionApi;
